declare function require(module: string): any;

import { PracticeCard } from '@holmescorp/card';
import { Carousel } from '@holmescorp/carousel';
import { CertificateCard } from '@holmescorp/certificate';
import '@holmescorp/cut-scores';
import { LandingPage } from '@holmescorp/landing-page';
import { RCSCard } from '@holmescorp/lcc-rcs';
import '@holmescorp/quiz-widgets';
import '@holmescorp/resource-parser';
import '@holmescorp/topic-progress';
import { Glossary } from 'glossary';
import { registry } from 'lcc-state';
import { LearningActivity } from 'learning-activity';
import {
	LPGroup,
	LPIcon,
	LPPageGroup,
	LPText,
	LPTool,
	LPToolCard,
	LPToolbar,
	LPTopicRoot,
	LPView,
	LPWidget
} from 'lp-widgets';

export function register_base_lp_widgets(): void {
	registry.define('LPView', LPView);
	registry.define('PageGroup', LPPageGroup);
	registry.define('Group', LPGroup);
	registry.define('TopicRoot', LPTopicRoot);
	registry.define('Text', LPText);
	registry.define('Icon', LPIcon);
	registry.define('Toolbar', LPToolbar);
	registry.define('Tool', LPTool);
	registry.define('ToolCard', LPToolCard);
	registry.define('Carousel', Carousel);
	registry.define('Widget', LPWidget);

	registry.define('LearningActivity', LearningActivity);
	registry.define('Glossary', Glossary);
	registry.define('LandingPage', LandingPage);

	// widgets for additional resources carousel
	registry.define('CertificateCard', CertificateCard);
	registry.define('PracticeCard', PracticeCard);
	registry.define('RCSCard', RCSCard);

	registry.define('ResourceCenter', (): Promise<any> => {
		return Promise.resolve(require('lcc-rcs').ResourceCenter);
	});
	registry.define('Search', (): Promise<any> => {
		return Promise.resolve(require('search-widget').Search);
	});
	registry.define('Video', (): Promise<any> => {
		return Promise.resolve(require('video').Video);
	});
	registry.define('Certificate', (): Promise<any> => {
		return Promise.resolve(require('certificate').Certificate);
	});
}
